export default __webpack_public_path__ + "static/media/docs-stress-compensation-man.f9ca7ed3.png";